import {formatCurrency} from '../../../utils';
import {formatPeriod} from '../utils/duration';
import ProjectTransactions from './ProjectTransactions';

const ProjectDetail = ({project, companies, onEdit, onDelete}) => {
    const company = companies.find(c => c.id === project.companyId);
    const incomeStats = project.incomeStats ?? [];
    const grossTotals = Object.fromEntries(incomeStats.map(s => [s.currencyCode, s.gross]));
    const netTotals = Object.fromEntries(incomeStats.map(s => [s.currencyCode, s.net]));
    const currencies = incomeStats.map(s => s.currencyCode).sort();
    const isActive = !project.endDate;
    const period = formatPeriod(project.startDate, project.endDate);

    return (
        <div className="entity-detail">
            <div className="entity-detail__header">
                <div className="entity-detail__heading">
                    <div className="entity-detail__title_wrapper">
                        <h3 className="entity-detail__title">{project.title}</h3>
                        <div className="entity-detail__header align-middle">
                            {company && (
                                <h3 className="entity-detail__meta entity-detail__center_vertical">in {company.name}</h3>
                            )}
                            <span className={`entity-detail__badge ${isActive ?
                                'entity-detail__badge--active' :
                                'entity-detail__badge--done'}`}>
                            {isActive ? 'Active' : 'Completed'}
                        </span>
                        </div>
                    </div>
                </div>
                <button className="detail-btn" onClick={onEdit}>Edit</button>
                <button className="detail-btn detail-btn--danger" onClick={onDelete}>Delete</button>
            </div>
            {period && <span className="entity-detail__meta">{period}</span>}

            {project.description && (
                <p className="entity-detail__notes">{project.description}</p>
            )}

            <div className="entity-detail__stats">
                <span className="entity-stats-count">{currencies.length} {currencies.length === 1 ? 'currency' : 'currencies'}</span>
                {currencies.length > 0 && (
                    <div className="entity-stats-grid">
                        {currencies.map(c => (
                            <div key={c} className="entity-stats-line">
                                <span className="entity-stats-line__currency">{c}</span>
                                <span className={`entity-stats-line__${grossTotals[c] ?? 0 >= 0 ? 'pos' : 'neg'}`}>{formatCurrency(grossTotals[c] ?? 0, c)}</span>
                                <span className="entity-stats-line__dim">gross</span>
                                <span className="entity-stats-line__sep">·</span>
                                <span className={`entity-stats-line__${netTotals[c] ?? 0 >= 0 ? 'pos' : 'neg'}`}>{formatCurrency(netTotals[c] ?? 0, c)}</span>
                                <span className="entity-stats-line__dim">net</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <ProjectTransactions key={project.id} project={project}/>
        </div>
    );
};

export default ProjectDetail;